import { render } from "./multistatus.vue?vue&type=template&id=833af2a4"
import script from "./multistatus.vue?vue&type=script&lang=js"
export * from "./multistatus.vue?vue&type=script&lang=js"

import "./multistatus.vue?vue&type=style&index=0&id=833af2a4&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__